let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jSMt1")).then(() => parcelRequire('hOPNl'));